import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { GovernmentSigmetsSvgComponent } from './government-sigmets-svg/government-sigmets-legend-svg';

export const GOVERNMENT_SIGMETS_LEGEND: TwcLegendParams = {
  title: 'SIGMETS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: GovernmentSigmetsSvgComponent },
  legendComponent: TwcLegendComponent
};
